import { unAuthorizedPost } from "../../services";
import { ADD_BOOKING, ADD_BOOKING_WITH_COUPONS, BOOKING_ENQUIRY, CHECK_AVAILABILITY, CHECK_ROOMTYPE_PRICING, GET_HOTEL_DETAILS, LIST_ALL_BOOKING_ENGINE_ACTIVITIES, LIST_MEAL_PLANS, VERIFY_COUPON } from "../../graphql";
import { RESET_AVAILABILITY_DATA, RESET_HOTEL_DETAILS, RESET_ROOMTYPE_PRICING, SAVE_AVAILABILITY_DATA, SAVE_HOTEL_DETAILS, SAVE_ROOMTYPE_PRICING, TOGGLE_LOADING } from "../types";
import { toast } from "react-toastify";

const bookingEngineUrl = `${process.env.REACT_APP_API_BASE_URL}/graphql/users`;

export const getHotelDetails = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await unAuthorizedPost(bookingEngineUrl, {
            query: GET_HOTEL_DETAILS,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            let {
                list_hotel_details: { data, status, is_private },
            } = apiResponse.data.data;

            dispatch({
                type: SAVE_HOTEL_DETAILS,
                payload: data,
            });
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return { status, is_private };
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const resetAllHotelDetails = () => {
    return async (dispatch) => {
        dispatch({ type: RESET_HOTEL_DETAILS });
    };
};

export const checkAvailability = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await unAuthorizedPost(bookingEngineUrl, {
            query: CHECK_AVAILABILITY,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            let {
                check_availability: { data },
            } = apiResponse.data.data;

            dispatch({
                type: SAVE_AVAILABILITY_DATA,
                payload: { data },
            });
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const resetAvailabilityData = () => {
    return async (dispatch) => {
        dispatch({ type: RESET_AVAILABILITY_DATA });
    };
};

export const checkRoomtypePricing = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await unAuthorizedPost(bookingEngineUrl, {
            query: CHECK_ROOMTYPE_PRICING,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            let {
                check_roomtype_pricing: { data },
            } = apiResponse.data.data;

            dispatch({
                type: SAVE_ROOMTYPE_PRICING,
                payload: data,
            });
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const resetRoomtypePricingData = () => {
    return async (dispatch) => {
        dispatch({ type: RESET_ROOMTYPE_PRICING });
    };
};

export const addBooking = (requestData, coupon) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse;
        const query = coupon ? ADD_BOOKING_WITH_COUPONS : ADD_BOOKING;
        
        apiResponse = await unAuthorizedPost(bookingEngineUrl, {
            query,
            variables: requestData,
        });

        console.log("API Response:", apiResponse); 

        const responseKey = coupon ? 'add_new_booking_with_coupons' : 'add_new_booking';
        if (apiResponse?.data?.customStatus) {
            const data = apiResponse?.data?.data?.[responseKey].data;
            
            if (data) {
                dispatch({ type: TOGGLE_LOADING, payload: false });
                return data;
            } else {
                dispatch({ type: TOGGLE_LOADING, payload: false });
                console.error(`Booking ${coupon ? 'with coupon' : 'without coupon'} failed: No data returned`);
            }
        } else {
            dispatch({ type: TOGGLE_LOADING, payload: false });
            console.error(`Booking ${coupon ? 'with coupon' : 'without coupon'} failed: customStatus is false`);
        }
    };
};

export const requestBooking = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await unAuthorizedPost(bookingEngineUrl, {
            query: BOOKING_ENQUIRY,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            toast.success("Booking enquiry submitted");
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return true;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const listMealPlans = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await unAuthorizedPost(bookingEngineUrl, {
            query: LIST_MEAL_PLANS,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            let {
                list_all_meal_plans: { data },
            } = apiResponse.data.data;
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return data;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const listAllBookingEngineActivities = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await unAuthorizedPost(bookingEngineUrl, {
            query: LIST_ALL_BOOKING_ENGINE_ACTIVITIES,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            let {
                list_all_activities: { data },
            } = apiResponse.data.data;
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return data;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const verifyCoupon = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });
        try {
            const apiResponse = await unAuthorizedPost(bookingEngineUrl, {
                query: VERIFY_COUPON,
                variables: requestData,
            });

            dispatch({ type: TOGGLE_LOADING, payload: false });

            if (apiResponse?.data?.customStatus) {
                const { verify_coupon } = apiResponse.data.data;

                return verify_coupon;
            } else {
                return {
                    valid: false,
                    message: apiResponse?.data?.message || "Invalid coupon",
                };
            }
        } catch (error) {
            dispatch({ type: TOGGLE_LOADING, payload: false });
            console.error("verifyCoupon error:", error);
            return {
                valid: false,
                message: "Something went wrong while verifying coupon.",
            };
        }
    };
};